import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'commons/src/api/baseQuery';
import { DeviceType, VirtualDevicesResponse } from 'commons/src/models/commonTypeScript';

export const virtualDevicesApi = createApi({
    reducerPath: 'virtualDevicesApi',
    baseQuery,
    tagTypes: ['VirtualDevices'],
    endpoints: builder => ({
        getVirtualDevices: builder.query<DeviceType[], string>({
            query: buildingId => ({
                url: `/locations/${buildingId}/devices`,
                method: 'GET',
            }),
            transformResponse: (response: VirtualDevicesResponse) => {
                return response.devices;
            },
            providesTags: ['VirtualDevices'],
        }),
    }),
});

export const { useGetVirtualDevicesQuery } = virtualDevicesApi;

export type GetVirtualDevicesResult = ReturnType<typeof useGetVirtualDevicesQuery>;
